export const cta = {
  eConsultation: 'Am I Suitable?',
  getStarted: 'Start Consultation',
};
